import React from 'react';
import { Paper, Box, Typography, Stack } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

// A single KPI tile: label, big value, optional trend %, optional icon + sub text.
const StatTile = ({ label, value, sub, trend, icon, accent = 'primary.main' }) => {
  const hasTrend = trend !== null && trend !== undefined;
  const up = hasTrend && trend >= 0;
  return (
    <Paper sx={{ p: 2.25, height: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="overline" color="text.secondary" noWrap>{label}</Typography>
        {icon && (
          <Box sx={{
            width: 30, height: 30, borderRadius: 1.5, display: 'grid', placeItems: 'center',
            color: accent, bgcolor: (t) => `${t.palette.primary.main}14`,
          }}>
            {icon}
          </Box>
        )}
      </Stack>
      <Stack direction="row" alignItems="baseline" spacing={1}>
        <Typography variant="h4" sx={{ fontWeight: 700, lineHeight: 1 }}>{value}</Typography>
        {hasTrend && (
          <Stack direction="row" alignItems="center" spacing={0.25}
            sx={{ color: up ? 'success.main' : 'error.main', fontWeight: 700, fontSize: '0.8rem' }}>
            {up ? <ArrowUpwardIcon sx={{ fontSize: 14 }} /> : <ArrowDownwardIcon sx={{ fontSize: 14 }} />}
            {Math.abs(trend)}%
          </Stack>
        )}
      </Stack>
      {sub && <Typography variant="caption" color="text.secondary" noWrap>{sub}</Typography>}
    </Paper>
  );
};

export default StatTile;
